<div class="mb-4 mt-2">
  <div class="buttons float-end">
    @if (columnConfigurationEnabled) {
      <button class="btn btn-nav" (click)="openColumnConfiguration()"
              title="{{ 'column-configuration.title' | translate }}">
        <span class="material-symbols-outlined">
          settings
        </span>
      </button>
    }

    @if (actionNew) {
      <button class="btn btn-nav" (click)="new()">
        <span class="material-symbols-outlined">
          add_box
        </span>
        <span>
          {{ 'new' | translate }}
        </span>
      </button>
    }

    @for (action of customTableActions(); track action; let i = $index) {
      <button class="btn btn-nav ms-3"
              (click)="action.action.emit()" [ladda]="action.loading" data-spinner-color="#000000">
        <span class="material-symbols-outlined">
        {{ action.icon }}
        </span>
        <span>
          {{ customTableActionsText()[i] | translate }}
        </span>
      </button>
    }
  </div>

  @if (filtersBesideSearch) {
    <!-- Filters beside search layout -->
    <div class="d-md-flex align-items-md-center gap-3">
      <div [ngClass]="{'d-none': !searchEnabled}" class="search">
        <input class="form-control" type="search" placeholder="{{ searchPlaceholder | translate }}" #input>
      </div>
      @if (filterElements().length > 0) {
        <div class="d-md-flex align-items-md-center gap-2 flex-wrap filters-container">
          @for (filter of filterElements(); track filter) {
            @switch (filter.type) {
              @case (FilterElementType.BOOLEAN) {
                <ng-container [ngTemplateOutlet]="boolFETplBeside" [ngTemplateOutletContext]="{$implicit: filter}"></ng-container>
              }
              @case (FilterElementType.DATE_RANGE){
                <ng-container [ngTemplateOutlet]="dateRFETplBeside" [ngTemplateOutletContext]="{$implicit: filter}"></ng-container>
              }
              @case (FilterElementType.ENUM){
                <ng-container [ngTemplateOutlet]="enumFETplBeside" [ngTemplateOutletContext]="{$implicit: filter}"></ng-container>
              }
              @case (FilterElementType.TEXT_SEARCH){
                <ng-container [ngTemplateOutlet]="textSFETplBeside" [ngTemplateOutletContext]="{$implicit: filter}"></ng-container>
              }
              @case (FilterElementType.RESULT_FIELD){
                <ng-container [ngTemplateOutlet]="resultFETplBeside" [ngTemplateOutletContext]="{$implicit: filter}"></ng-container>
              }
            }
          }
        </div>
      }
    </div>
    <!-- Multi-filter gets its own row below -->
    @for (filter of filterElements(); track filter) {
      @if (filter.type === FilterElementType.RESULT_FIELD_MULTI) {
        <div class="mt-2">
          <ng-container [ngTemplateOutlet]="resultMultiFETpl" [ngTemplateOutletContext]="{$implicit: filter}"></ng-container>
        </div>
      }
    }
  } @else {
    <!-- Traditional layout -->
    <div [ngClass]="{'d-none': !searchEnabled}" class="float-start search">
      <input class="form-control" type="search" placeholder="{{ searchPlaceholder | translate }}" #input>
    </div>
  }

  <div class="clearfix"></div>
</div>

@if (filterElements().length > 0 && !filtersBesideSearch) {
  <div class="mb-3">
    <div class="row">
      @for (filter of filterElements(); track filter) {
        @switch (filter.type) {
          @case (FilterElementType.BOOLEAN) {
            <ng-container [ngTemplateOutlet]="boolFETpl" [ngTemplateOutletContext]="{$implicit: filter}"></ng-container>
          }
          @case (FilterElementType.DATE_RANGE){
            <ng-container [ngTemplateOutlet]="dateRFETpl" [ngTemplateOutletContext]="{$implicit: filter}"></ng-container>
          }
          @case (FilterElementType.ENUM){
            <ng-container [ngTemplateOutlet]="enumFETpl" [ngTemplateOutletContext]="{$implicit: filter}"></ng-container>
          }
          @case (FilterElementType.TEXT_SEARCH){
            <ng-container [ngTemplateOutlet]="textSFETpl" [ngTemplateOutletContext]="{$implicit: filter}"></ng-container>
          }
          @case (FilterElementType.RESULT_FIELD){
            <ng-container [ngTemplateOutlet]="resultFETpl" [ngTemplateOutletContext]="{$implicit: filter}"></ng-container>
          }
          @case (FilterElementType.RESULT_FIELD_MULTI){
            <ng-container [ngTemplateOutlet]="resultMultiFETpl" [ngTemplateOutletContext]="{$implicit: filter}"></ng-container>
          }
        }
      }
    </div>
  </div>
}

<!-- Templates for traditional layout, see besides below -->
<ng-template #boolFETpl let-elem>
  <boolean-filter-element
    [size]="elem.size"
    [filterActive]="!!customFilters[elem.filterKey]"
    [filterKey]="elem.filterKey"
    [label]="elem.label"
    (filterTerm)="updateCustomFilter(elem, $event)"
  ></boolean-filter-element>
</ng-template>
<ng-template #dateRFETpl let-elem>
  <date-range-filter-element
    [size]="elem.size"
    [filterActive]="!!customFilters[elem.filterKey]"
    [filterKey]="elem.filterKey"
    [label]="elem.label"
    [start]="elem.start"
    [end]="elem.end"
    (filterTerm)="updateCustomFilter(elem, $event)"></date-range-filter-element>
</ng-template>
<ng-template #enumFETpl let-elem>
  <selection-filter-element
    [size]="elem.size"
    [filterActive]="!!customFilters[elem.filterKey]"
    [filterKey]="elem.filterKey"
    [label]="elem.label"
    [values]="elem.values"
    [multiple]="elem.multiple"
    [shouldTranslate]="elem.translate"
    [searchable]="elem.searchable"
    [totalValues]="elem.totalValues"
    (filterTerm)="updateCustomFilter(elem, $event)"
    (searchTerm)="elem.onSearchTermChanged($event)"
  ></selection-filter-element>
</ng-template>
<ng-template #textSFETpl let-elem>
  <text-search-filter-element
    [size]="elem.size"
    [filterActive]="!!customFilters[elem.filterKey]"
    [filterKey]="elem.filterKey"
    [label]="elem.label"
    (filterTerm)="updateCustomFilter(elem, $event)"></text-search-filter-element>
</ng-template>
<ng-template #resultFETpl let-elem>
  <result-field-filter-element
    [size]="elem.size"
    [filterActive]="!!resultFilters[elem.filterKey]"
    [filterKey]="elem.filterKey"
    [label]="elem.label"
    [fields]="elem.fields"
    [fieldPlaceholder]="elem.fieldPlaceholder"
    [valuePlaceholder]="elem.valuePlaceholder"
    (resultFilterChange)="updateResultFilter(elem, $event)"></result-field-filter-element>
</ng-template>
<ng-template #resultMultiFETpl let-elem>
  <result-field-multi-filter-element
    [size]="elem.size"
    [filterActive]="hasMultiFilterActive(elem.filterKey)"
    [filterKey]="elem.filterKey"
    [label]="elem.label"
    [fields]="elem.fields"
    [fieldPlaceholder]="elem.fieldPlaceholder"
    [valuePlaceholder]="elem.valuePlaceholder"
    (resultFiltersChange)="updateMultiResultFilters(elem, $event)"></result-field-multi-filter-element>
</ng-template>

<!-- Templates for beside layout with proper sizing -->
<ng-template #boolFETplBeside let-elem>
  <div [ngClass]="getBesideLayoutSize(elem.size)">
    <boolean-filter-element
      [size]="elem.size"
      [filterActive]="!!customFilters[elem.filterKey]"
      [filterKey]="elem.filterKey"
      [label]="elem.label"
      (filterTerm)="updateCustomFilter(elem, $event)"
    ></boolean-filter-element>
  </div>
</ng-template>
<ng-template #dateRFETplBeside let-elem>
  <div [ngClass]="getBesideLayoutSize(elem.size)">
    <date-range-filter-element
      [size]="elem.size"
      [filterActive]="!!customFilters[elem.filterKey]"
      [filterKey]="elem.filterKey"
      [label]="elem.label"
      [start]="elem.start"
      [end]="elem.end"
      (filterTerm)="updateCustomFilter(elem, $event)"></date-range-filter-element>
  </div>
</ng-template>
<ng-template #enumFETplBeside let-elem>
  <div [ngClass]="getBesideLayoutSize(elem.size)">
    <selection-filter-element
      [size]="elem.size"
      [filterActive]="!!customFilters[elem.filterKey]"
      [filterKey]="elem.filterKey"
      [label]="elem.label"
      [values]="elem.values"
      [multiple]="elem.multiple"
      [shouldTranslate]="elem.translate"
      [searchable]="elem.searchable"
      [totalValues]="elem.totalValues"
      (filterTerm)="updateCustomFilter(elem, $event)"
      (searchTerm)="elem.onSearchTermChanged($event)"
    ></selection-filter-element>
  </div>
</ng-template>
<ng-template #textSFETplBeside let-elem>
  <div [ngClass]="getBesideLayoutSize(elem.size)">
    <text-search-filter-element
      [size]="elem.size"
      [filterActive]="!!customFilters[elem.filterKey]"
      [filterKey]="elem.filterKey"
      [label]="elem.label"
      (filterTerm)="updateCustomFilter(elem, $event)"></text-search-filter-element>
  </div>
</ng-template>
<ng-template #resultFETplBeside let-elem>
  <div [ngClass]="getBesideLayoutSize(elem.size)">
    <result-field-filter-element
      [size]="elem.size"
      [filterActive]="!!resultFilters[elem.filterKey]"
      [filterKey]="elem.filterKey"
      [label]="elem.label"
      [fields]="elem.fields"
      [fieldPlaceholder]="elem.fieldPlaceholder"
      [valuePlaceholder]="elem.valuePlaceholder"
      (resultFilterChange)="updateResultFilter(elem, $event)"></result-field-filter-element>
  </div>
</ng-template>
<ng-template #resultMultiFETplBeside let-elem>
  <div [ngClass]="getBesideLayoutSize(elem.size)">
    <result-field-multi-filter-element
      [size]="elem.size"
      [filterActive]="hasMultiFilterActive(elem.filterKey)"
      [filterKey]="elem.filterKey"
      [label]="elem.label"
      [fields]="elem.fields"
      [fieldPlaceholder]="elem.fieldPlaceholder"
      [valuePlaceholder]="elem.valuePlaceholder"
      (resultFiltersChange)="updateMultiResultFilters(elem, $event)"></result-field-multi-filter-element>
  </div>
</ng-template>

<div class="card">
  <!-- Loading skeleton -->
  @if (dataSource.loading | async) {
    <div class="table-responsive skeleton-table">
      <table class="table table-responsive table-striped">
        <thead>
          <tr class="placeholder-glow">
            @for (column of actualDisplayedColumns(); track column.displayedProperty) {
              <th class="mr-2">
                <span class="placeholder skeleton-bar skeleton-bar--header"></span>
              </th>
            }
          </tr>
        </thead>
        <tbody class="placeholder-glow">
          @for (row of [0, 1, 2, 3, 4]; track row) {
            <tr>
              @for (column of actualDisplayedColumns(); track column.displayedProperty) {
                <td class="mr-2">
                  <span class="placeholder skeleton-bar"></span>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- Actual table -->
  <div class="table-responsive" [ngClass]="{'d-none': dataSource.count === 0 || (dataSource.loading | async)}">
    <table mat-table [dataSource]="dataSource" matSort [matSortActive]="sort.active" [matSortDirection]="sort.direction"
            matSortDisableClear class="overflow-auto table table-responsive table-striped table-hover">
      @for (column of actualDisplayedColumns(); track column.displayedProperty) {
        @if (column.displayedProperty !== 'actions') {
          <ng-container matColumnDef="{{column.displayedProperty}}">
            @if (column.sortable) {
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="mr-2">
                @if (column.name) {
                  <div>
                    @if (column.translateHeader) {
                      <span>{{column.name | translate}}</span>
                    } @else {
                      <span>{{column.name}}</span>
                    }
                  </div>
                } @else {
                  {{column.displayedProperty| titlecase}}
                }
              </th>
            } @else {
              <th mat-header-cell *matHeaderCellDef class="mr-2">
                @if (column.name) {
                  <div>
                    @if (column.translateHeader) {
                      <span>{{column.name | translate}}</span>
                    } @else {
                      <span>{{column.name}}</span>
                    }
                  </div>
                } @else {
                  {{column.displayedProperty | titlecase}}
                }
              </th>
            }
            <td mat-cell (click)="show($event, item.id)" *matCellDef="let item" class="mr-2" [ngClass]="{'clickable': showEvent.observed}">
              @if (processedData[item.id] && processedData[item.id][column.displayedProperty] && processedData[item.id][column.displayedProperty]() !== undefined) {
                @if (column.template) {
                  <ng-container
                    [ngTemplateOutlet]="column.template"
                    [ngTemplateOutletContext]="{$implicit: item}"
                  ></ng-container>
                }
                @if (!column.template && column.translate) {
                  <span>{{ processedData[item.id][column.displayedProperty]()! | translate }}</span>
                }
                @if (!column.template && !column.translate && isResultColumn(column)) {
                  <span
                    class="result-cell-truncated"
                    [attr.title]="needsTruncation(processedData[item.id][column.displayedProperty]()) ? processedData[item.id][column.displayedProperty]() : null">
                    {{ truncateForCell(processedData[item.id][column.displayedProperty]()) }}
                  </span>
                }
                @if (!column.template && !column.translate && !isResultColumn(column)) {
                  <span [innerHTML]="processedData[item.id][column.displayedProperty]()"></span>
                }
              }
            </td>
          </ng-container>
        }
      }

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="col-auto">
            <span>&nbsp;</span>
          </th>
          <td mat-cell *matCellDef="let item"  class="col-auto">
            <!-- Primary Actions -->
            @for (action of customActions(); track action; let i = $index) {
              @if(action.primaryAction && customActionVisibilityMap[item.id][i]()) {
                <button (click)="emitAction(action, item.id)" class="btn btn-sm" [ngClass]="customActionClassMap[item.id][i]"
                        [class.disabled]="!customActionActivationMap[item.id][i]()"
                        style="width: 130px">{{customActionTextMap[item.id][i] | translate}}</button>
              }
            }
            <!-- Icon Actions -->
            @for (action of iconActions(); track action; let i = $index) {
              @if (iconActionVisibilityMap[item.id] && iconActionVisibilityMap[item.id][i] && iconActionVisibilityMap[item.id][i]()) {
                <button (click)="emitAction(action, item.id)"
                        class="btn btn-sm me-1 {{action.className}}"
                        data-bs-toggle="tooltip" data-bs-placement="top" title="{{iconActionTextMap[item.id][i] | translate}}"
                        [class.disabled]="!iconActionActivationMap[item.id][i]()">
                    <span class="material-symbols-outlined">{{action.icon}}</span>
                    @if (action.secondaryIcon) {
                      <span class="material-symbols-outlined ms-1">{{action.secondaryIcon}}</span>
                    }
              </button>
            }
          }
          @if (hasActivatedCustomNonPrimaryMap[item.id] && hasActivatedCustomNonPrimaryMap[item.id]()) {
            <a href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" class="ms-2">
              <span class="material-symbols-outlined ">more_vert</span>
            </a>
            <ul class="dropdown-menu">
              @for (action of customActions(); track action; let i = $index) {
                @if (!action.primaryAction && customActionVisibilityMap[item.id][i]()) {
                  <li><a
                    class="dropdown-item"
                    (click)="emitAction(action, item.id)"
                    [class.disabled]="!customActionActivationMap[item.id][i]()"
                  >{{customActionTextMap[item.id][i] | translate}}</a></li>
                }
              }
            </ul>
          }
        </td>
      </ng-container>

        <tr mat-header-row *matHeaderRowDef="headerDef()"></tr>

      <tr mat-row *matRowDef="let row; columns: headerDef()"></tr>
    </table>

    <mat-paginator [ngClass]="{'d-none': !showPagination}" #paginator></mat-paginator>
  </div>

  @if (dataSource.count === 0 && (dataSource.loading | async) === false && !!dataSource.data) {
    <div class="p-4 text-muted justify-content-center text-center align-content-center">
      <ng-content></ng-content>
    </div>
  }

  <app-error [error]="error"></app-error>

</div>
